const buttonShadow = color => `4px 4px 0 ${color}`;
const imageShadow = color => `-8px 8px 0 ${color}`;

export { buttonShadow, imageShadow };
